module.exports = __webpack_public_path__ + "static/media/Video.1e49df8f.svg";